// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Compact Study Merge Modal - Minimal whitespace design */

.study-merge-modal .ant-modal-content {
  border-radius: 4px;
  border: 1px solid #E2E8F1;
  -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  padding: 0;
}

.study-merge-modal .ant-modal-header {
  border-bottom: 1px solid #E2E8F1;
  margin-bottom: 0;
  padding: 8px 12px;
  min-height: auto;
}

.study-merge-modal .ant-modal-title {
  font-size: 13px;
  font-weight: 600;
  color: #1F2937;
}

.study-merge-modal .ant-modal-close {
  padding: 4px;
}

.study-merge-modal.compact .ant-modal-body {
  padding: 0;
}

.merge-modal-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 0;
  padding: 0;
}

.merge-modal-content.compact {
  gap: 0;
}

.merge-section {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 4px;
  padding: 8px 12px;
  border-bottom: 1px solid #F0F0F0;
}

.merge-section.compact {
  gap: 4px;
  padding: 8px 12px;
}

.merge-section-title {
  font-size: 11px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  margin: 0;
}

.merge-section-title.compact {
  font-size: 11px;
  padding: 0;
  margin: 0;
}

.merge-table-wrap {
  border: 1px solid #E2E8F1;
  border-radius: 2px;
  overflow: hidden;
  max-height: 200px;
}

.merge-table-wrap.compact {
  border: 1px solid #E2E8F1;
  border-radius: 2px;
  overflow: hidden;
  max-height: 180px;
}

.merge-table .ant-table-thead > tr > th {
  background: #FAFAFA;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  padding: 4px 8px !important;
  border-bottom: 1px solid #E2E8F1;
  height: auto;
}

.merge-table.compact .ant-table-thead > tr > th {
  padding: 4px 6px !important;
  font-size: 10px;
}

.merge-table .ant-table-tbody > tr > td {
  font-size: 12px;
  padding: 4px 8px !important;
  height: auto;
}

.merge-table.compact .ant-table-tbody > tr > td {
  font-size: 11px;
  padding: 3px 6px !important;
}

.merge-table .ant-table-tbody > tr {
  border-bottom: 1px solid #F0F0F0;
}

.merge-table .ant-table-tbody > tr:last-child {
  border-bottom: none;
}

/* Panels Container */

.merge-panels-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid #F0F0F0;
}

.merge-panels-container.compact {
  gap: 8px;
  grid-template-columns: 1fr 1fr;
}

.merge-drop-panel {
  border: 1px solid #E2E8F1;
  border-radius: 2px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  background: #FAFAFA;
  overflow: hidden;
}

.merge-drop-panel.child {
  border-color: #90EE90;
  background: #FFFBF0;
}

.merge-drop-panel.parent {
  border-color: #FFD700;
  background: #FFFEF0;
}

.merge-panel-header {
  background: #F0F0F0;
  padding: 6px 8px;
  font-size: 12px;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #E2E8F1;
  margin: 0;
}

.merge-panel-header.compact {
  padding: 6px 8px;
  font-size: 11px;
  background: #F5F5F5;
}

.merge-drop-panel.child .merge-panel-header {
  background: #E8F5E9;
  border-bottom-color: #90EE90;
}

.merge-drop-panel.parent .merge-panel-header {
  background: #FFFDE7;
  border-bottom-color: #FFD700;
}

.merge-drop-zone {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  min-height: 120px;
  padding: 8px;
  border: 2px dashed #D0D0D0;
  border-radius: 2px;
  background: #FAFAFA;
  overflow-y: auto;
  -webkit-transition: background-color 0.2s;
  transition: background-color 0.2s;
}

.merge-drop-zone:hover {
  background-color: #F5F5F5;
}

.merge-drop-zone:active,
.merge-drop-zone.dragover {
  background-color: #E8F5E9;
  border-color: #90EE90;
}

.empty-drop-zone {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  height: 100%;
  color: #999;
  font-size: 12px;
  font-style: italic;
  text-align: center;
}

.merge-assignment-table .ant-table {
  margin-bottom: 0;
}

.merge-assignment-table.compact .ant-table-thead > tr > th {
  padding: 4px 6px !important;
  font-size: 10px;
}

.merge-assignment-table.compact .ant-table-tbody > tr > td {
  font-size: 11px;
  padding: 3px 6px !important;
}

.merge-assignment-table .ant-table-tbody > tr {
  border-bottom: 1px solid #F0F0F0;
}

/* Modal Actions */

.merge-modal-actions {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  gap: 6px;
  padding: 8px 12px;
  background: #FAFAFA;
  border-top: 1px solid #E2E8F1;
}

.merge-modal-actions.compact {
  gap: 6px;
  padding: 8px 12px;
}

.merge-modal-actions .ant-btn {
  min-width: auto;
  padding: 4px 12px;
  font-size: 12px;
  height: 28px;
}

.merge-modal-actions .ant-btn.ant-btn-primary {
  min-width: 70px;
}

/* Input adjustments */

.merge-section .ant-input-textarea {
  font-size: 12px;
}

.merge-section .ant-input-textarea textarea {
  padding: 6px 8px !important;
  font-size: 12px;
  line-height: 1.4;
}

.ant-input-textarea-focused {
  border-color: #1890ff;
  -webkit-box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.15);
          box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.15);
}
`, "",{"version":3,"sources":["webpack://./components/StudyMergeModal.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iDAAyC;UAAzC,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAO;MAAP,WAAO;UAAP,OAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAiC;EAAjC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,kBAAkB;;AAClB;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;;AACtB;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sDAA8C;UAA9C,8CAA8C;AAChD","sourcesContent":["/* Compact Study Merge Modal - Minimal whitespace design */\r\n\r\n.study-merge-modal .ant-modal-content {\r\n  border-radius: 4px;\r\n  border: 1px solid #E2E8F1;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);\r\n  padding: 0;\r\n}\r\n\r\n.study-merge-modal .ant-modal-header {\r\n  border-bottom: 1px solid #E2E8F1;\r\n  margin-bottom: 0;\r\n  padding: 8px 12px;\r\n  min-height: auto;\r\n}\r\n\r\n.study-merge-modal .ant-modal-title {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #1F2937;\r\n}\r\n\r\n.study-merge-modal .ant-modal-close {\r\n  padding: 4px;\r\n}\r\n\r\n.study-merge-modal.compact .ant-modal-body {\r\n  padding: 0;\r\n}\r\n\r\n.merge-modal-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0;\r\n  padding: 0;\r\n}\r\n\r\n.merge-modal-content.compact {\r\n  gap: 0;\r\n}\r\n\r\n.merge-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  padding: 8px 12px;\r\n  border-bottom: 1px solid #F0F0F0;\r\n}\r\n\r\n.merge-section.compact {\r\n  gap: 4px;\r\n  padding: 8px 12px;\r\n}\r\n\r\n.merge-section-title {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: #666;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.02em;\r\n  margin: 0;\r\n}\r\n\r\n.merge-section-title.compact {\r\n  font-size: 11px;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.merge-table-wrap {\r\n  border: 1px solid #E2E8F1;\r\n  border-radius: 2px;\r\n  overflow: hidden;\r\n  max-height: 200px;\r\n}\r\n\r\n.merge-table-wrap.compact {\r\n  border: 1px solid #E2E8F1;\r\n  border-radius: 2px;\r\n  overflow: hidden;\r\n  max-height: 180px;\r\n}\r\n\r\n.merge-table .ant-table-thead > tr > th {\r\n  background: #FAFAFA;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  padding: 4px 8px !important;\r\n  border-bottom: 1px solid #E2E8F1;\r\n  height: auto;\r\n}\r\n\r\n.merge-table.compact .ant-table-thead > tr > th {\r\n  padding: 4px 6px !important;\r\n  font-size: 10px;\r\n}\r\n\r\n.merge-table .ant-table-tbody > tr > td {\r\n  font-size: 12px;\r\n  padding: 4px 8px !important;\r\n  height: auto;\r\n}\r\n\r\n.merge-table.compact .ant-table-tbody > tr > td {\r\n  font-size: 11px;\r\n  padding: 3px 6px !important;\r\n}\r\n\r\n.merge-table .ant-table-tbody > tr {\r\n  border-bottom: 1px solid #F0F0F0;\r\n}\r\n\r\n.merge-table .ant-table-tbody > tr:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n/* Panels Container */\r\n.merge-panels-container {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 8px;\r\n  padding: 8px 12px;\r\n  border-bottom: 1px solid #F0F0F0;\r\n}\r\n\r\n.merge-panels-container.compact {\r\n  gap: 8px;\r\n  grid-template-columns: 1fr 1fr;\r\n}\r\n\r\n.merge-drop-panel {\r\n  border: 1px solid #E2E8F1;\r\n  border-radius: 2px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: #FAFAFA;\r\n  overflow: hidden;\r\n}\r\n\r\n.merge-drop-panel.child {\r\n  border-color: #90EE90;\r\n  background: #FFFBF0;\r\n}\r\n\r\n.merge-drop-panel.parent {\r\n  border-color: #FFD700;\r\n  background: #FFFEF0;\r\n}\r\n\r\n.merge-panel-header {\r\n  background: #F0F0F0;\r\n  padding: 6px 8px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #333;\r\n  border-bottom: 1px solid #E2E8F1;\r\n  margin: 0;\r\n}\r\n\r\n.merge-panel-header.compact {\r\n  padding: 6px 8px;\r\n  font-size: 11px;\r\n  background: #F5F5F5;\r\n}\r\n\r\n.merge-drop-panel.child .merge-panel-header {\r\n  background: #E8F5E9;\r\n  border-bottom-color: #90EE90;\r\n}\r\n\r\n.merge-drop-panel.parent .merge-panel-header {\r\n  background: #FFFDE7;\r\n  border-bottom-color: #FFD700;\r\n}\r\n\r\n.merge-drop-zone {\r\n  flex: 1;\r\n  min-height: 120px;\r\n  padding: 8px;\r\n  border: 2px dashed #D0D0D0;\r\n  border-radius: 2px;\r\n  background: #FAFAFA;\r\n  overflow-y: auto;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.merge-drop-zone:hover {\r\n  background-color: #F5F5F5;\r\n}\r\n\r\n.merge-drop-zone:active,\r\n.merge-drop-zone.dragover {\r\n  background-color: #E8F5E9;\r\n  border-color: #90EE90;\r\n}\r\n\r\n.empty-drop-zone {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  color: #999;\r\n  font-size: 12px;\r\n  font-style: italic;\r\n  text-align: center;\r\n}\r\n\r\n.merge-assignment-table .ant-table {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.merge-assignment-table.compact .ant-table-thead > tr > th {\r\n  padding: 4px 6px !important;\r\n  font-size: 10px;\r\n}\r\n\r\n.merge-assignment-table.compact .ant-table-tbody > tr > td {\r\n  font-size: 11px;\r\n  padding: 3px 6px !important;\r\n}\r\n\r\n.merge-assignment-table .ant-table-tbody > tr {\r\n  border-bottom: 1px solid #F0F0F0;\r\n}\r\n\r\n/* Modal Actions */\r\n.merge-modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 6px;\r\n  padding: 8px 12px;\r\n  background: #FAFAFA;\r\n  border-top: 1px solid #E2E8F1;\r\n}\r\n\r\n.merge-modal-actions.compact {\r\n  gap: 6px;\r\n  padding: 8px 12px;\r\n}\r\n\r\n.merge-modal-actions .ant-btn {\r\n  min-width: auto;\r\n  padding: 4px 12px;\r\n  font-size: 12px;\r\n  height: 28px;\r\n}\r\n\r\n.merge-modal-actions .ant-btn.ant-btn-primary {\r\n  min-width: 70px;\r\n}\r\n\r\n/* Input adjustments */\r\n.merge-section .ant-input-textarea {\r\n  font-size: 12px;\r\n}\r\n\r\n.merge-section .ant-input-textarea textarea {\r\n  padding: 6px 8px !important;\r\n  font-size: 12px;\r\n  line-height: 1.4;\r\n}\r\n\r\n.ant-input-textarea-focused {\r\n  border-color: #1890ff;\r\n  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.15);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
